import React, { useState, useEffect, useRef, useContext } from 'react';
import CrmContactsTable from './CrmContactsTable';
import { store } from 'components/Store';
import RemoveContactsModal from './RemoveContactsModal/RemoveContactsModal';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import RemoveContactTagsModal from './CrmContactsTable/CrmContactsListBar/RemoveContactTagsModal';
import ChampionStatusModal from './CrmContactsTable/CrmContactsListBar/ChampionStatusModal';
import CrmContactsFilters from './CrmContactsFilters';
import CrmContactsTableSkeleton from './CrmContactsTable/CrmContactsSkeleton';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';

const CrmContacts = (props) => {
  const globalState = useContext(store);
  const { dispatch, state } = globalState;
  const {
    selectedCrmContacts,
    crmContactsTotalHits,
    showRemoveContactsModal,
    showRemoveContactTagsModal,
    showChangeChampionStatusModal,
  } = state;

  const { filters, groupPage } = props;

  const [mainLoading, setMainLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  const initialCall = useRef(null);

  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const { groupId } = params;
  const isMobile = useIsMobile();

  const setShowAddTagsModal = (value) => {
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'showAddTagsModalCrmContacts',
      value,
    });
  };

  const setSelectedCrmContacts = (value) => {
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'selectedCrmContacts',
      value,
    });
  };

  const setTotalHits = (value) => {
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'crmContactsTotalHits',
      value,
    });
  };

  const resetSelectedContacts = () => {
    setSelectedCrmContacts({
      selectedAll: false,
      selectedIds: [],
      selectedAllVisible: [],
    });
  };

  useEffect(() => {
    return () => {
      resetSelectedContacts();
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (!getUrlParam('sort') && !getUrlParam('search')) {
        const query = new URLSearchParams(window.location.search);
        query.set('sort', 'lastName_asc');
        navigate({ search: query.toString() }, { replace: true, state: location.state });
      }
      setMainLoading(false);
    }, 300);
  }, []);

  return (
    <>
      <RemoveContactsModal
        selectedCrmContacts={selectedCrmContacts}
        setSelectedCrmContacts={setSelectedCrmContacts}
        resetSelectedContacts={resetSelectedContacts}
        totalHits={crmContactsTotalHits}
        initialCall={initialCall}
        showRemoveContactsModal={showRemoveContactsModal}
      />
      <RemoveContactTagsModal
        totalHits={crmContactsTotalHits}
        showRemoveContactTagsModal={showRemoveContactTagsModal}
      />
      <div className={`main-content pl-md-4 pl-3 h-100 d-flex flex-column ${groupPage ? 'pt-4' : ''}`}>
        {!groupId && !isMobile && <CrmContactsFilters />}
        <div className='d-flex flex-column flex-grow-1'>
          {mainLoading ? (
            <div className={`row mx-0 h-100`}>
              <div className='flex-grow-1' style={{ overflow: 'hidden' }}>
                <CrmContactsTableSkeleton />
              </div>
            </div>
          ) : (
            <CrmContactsTable
              selectedCrmContacts={selectedCrmContacts}
              setSelectedCrmContacts={setSelectedCrmContacts}
              setTotalHits={setTotalHits}
              isLoadingState={{ isLoading, setIsLoading }}
              initialCall={initialCall}
              setShowAddTagsModal={setShowAddTagsModal}
              filters={filters}
            />
          )}
        </div>
      </div>
      <ChampionStatusModal
        isOpen={showChangeChampionStatusModal}
        totalHits={crmContactsTotalHits}
        setIsOpen={(value) => {
          dispatch({
            type: 'MODIFY_SECTION',
            parameter: 'showChangeChampionStatusModal',
            value,
          });
        }}
      />
    </>
  );
};

export default CrmContacts;
